module.exports = __webpack_public_path__ + "img/kma_detail.594d1da4.jpg";